module.exports = __webpack_public_path__ + "static/media/81-f3EpuvGL._AC_SL1500_.e51b77e5.jpg";